import { call } from 'redux-saga/effects';
import { getPathWithQueryString, pageContext } from 'ctm-util-functions';
import { validateAllPreviousPages } from './validate_all_previous_pages';
import { runApiOnMountForPage } from './run_api_on_mount_for_page';

/**
 * Saga to progress user to a specific page, checking journey validation for all previous pages,
 * then run the onMount Api calls for the page to load
 * @param {Object} action - The action that describes the requested page to be progressed to
 */
export const progressToPage = function* (action) {
    const { pageName, pageSchemaModel = pageContext.getProps().models.pageSchemaModel } = action;
    const pageSchema = pageSchemaModel.getPageSchemaByName(pageName);
    const browserHistory = pageContext.getProps().browserHistory;
    const pageState = pageContext.getProps().pageState || {};

    if (!pageSchema) {
        throw new Error(`Invalid pageSchema, unable to progress to page: ${pageName}`);
    }
    // Validate all previous pages, detect the first page with an error and make that the page to load.
    const firstPageWithError = yield call(validateAllPreviousPages, pageSchemaModel, pageSchema);
    const actualPageToLoad = firstPageWithError || pageSchema;
    yield call(runApiOnMountForPage, actualPageToLoad, pageState);

    // Navigate to page with errors, or simply the next page.
    yield call(browserHistory.replace, getPathWithQueryString(actualPageToLoad.path));
};
